<template>
  <div class="snippet snippet_s" :class="cssClass">
    <router-link
      :to="documentRoute"
      class="snippet__body snippet__link"
      :target="openInNewWindow ? '_blank' : ''"
    >
      <span v-if="designation" class="snippet__designation">
        {{ designation }}
      </span>
      <span
        v-if="document.title"
        class="snippet__title"
        :title="document.title"
      >
        {{ document.title | truncateText(140) }}
      </span>
    </router-link>
  </div>
</template>

<script>
import {
  DOCUMENT_FORMAT_HTML,
  DOCUMENT_FORMAT_SCAN
} from '@src/api/entities/ApiDocumentSearchCard';
import DocumentRoute from '@@/document/mixins/DocumentRoute';

export default {
  mixins: [DocumentRoute],

  props: {
    document: {
      type: Object,
      required: true
    },

    format: {
      type: String,
      default: null
    },

    cssClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    openInNewWindow() {
      return this.$store.getters.getOpenInWindow;
    },

    designation() {
      if (this.document.designation) return this.document.designation;
      
      let type = this.document.type,
        number = this.document.number;

      return type + (type && number ? ' ' : '') + number;
    },

    documentRoute() {
      if (this.format === DOCUMENT_FORMAT_HTML) {
        return this.makeDocumentHtmlRoute(this.document.id, this.target);
      } else if (this.format === DOCUMENT_FORMAT_SCAN) {
        return this.makeDocumentScanRoute(this.document.id, this.target);
      }
      return this.makeDocumentRoute(this.document.id);
    }
  }
};
</script>
